import { render, staticRenderFns } from "./ExpenseSubCategoryEdit_Detail.vue?vue&type=template&id=87717a8e&"
import script from "./ExpenseSubCategoryEdit_Detail.vue?vue&type=script&lang=js&"
export * from "./ExpenseSubCategoryEdit_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports